
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import ruleMixin from '@/minix/ruleMixin';
import api from '@/api';
import Swal from 'sweetalert2';
import DateRange from '@/components/DateRange.vue';
import moment from 'moment';

const { feature } = api;

@Component({
  components: {
    DateRange,
  },
  mixins: [ruleMixin],
})
export default class ServiceUpdateForm extends Vue {
  @Prop() private id!: string;

  private loading = false;

  private valid = true;

  private form = {
    title: '',
    link: '',
    startOn: '',
  };

  private async submit() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      const { status } = this.isEdit
        ? await feature.edit(this.id, this.form)
        : await feature.add(this.form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        await this.$router.back();
      }
    }
  }

  private async cancel() {
    await this.$router.back();
  }

  private get isEdit() {
    return !!this.id;
  }

  private get title() {
    return this.isEdit ? '修改' : '新增';
  }

  private async setForm(form: any) {
    const startOn = moment(form.startOn).format('YYYY-MM-DD');
    this.form = { ...form, startOn };
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ServiceUpdateForm) => void) | boolean) => void,
  ) {
    if (to.name === 'serviceUpdateEdit') {
      const { data } = await feature.get(to.params.id);
      await next(async (vm) => {
        vm.setForm(data);
      });
    } else {
      await next(true);
    }
  }
}
